/*
 * QuestionnaireEdit Messages
 *
 * This contains all the text for the QuestionnaireEdit component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.QuestionnaireEdit';

export default defineMessages({
  editQuestionnaire: {
    id: `${scope}.editQuestionnaire`,
    defaultMessage: 'Edit Questionnaire',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  language: {
    id: `${scope}.language`,
    defaultMessage: 'Language',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  questions: {
    id: `${scope}.questions`,
    defaultMessage: 'Questions',
  },
  section: {
    id: `${scope}.section`,
    defaultMessage: 'Section',
  },
  of: {
    id: `${scope}.of`,
    defaultMessage: 'of',
  },
  descriptionOpt: {
    id: `${scope}.descriptionOpt`,
    defaultMessage: 'Description (optional)',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  published: {
    id: `${scope}.published`,
    defaultMessage: 'Published',
  },
  unpublished: {
    id: `${scope}.unpublished`,
    defaultMessage: 'Unpublished',
  },
  preview: {
    id: `${scope}.preview`,
    defaultMessage: 'Preview',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Code',
  },
});
